import { render, staticRenderFns } from "./TotalSummaryComponent.vue?vue&type=template&id=5c32473d&"
import script from "./TotalSummaryComponent.vue?vue&type=script&lang=js&"
export * from "./TotalSummaryComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports